import { render, staticRenderFns } from "./childrenTable.vue?vue&type=template&id=3451e7f2&"
import script from "./childrenTable.vue?vue&type=script&lang=js&"
export * from "./childrenTable.vue?vue&type=script&lang=js&"
import style0 from "./childrenTable.vue?vue&type=style&index=0&id=3451e7f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports